import { render, staticRenderFns } from "./addshopCategory.vue?vue&type=template&id=7bc24da9&scoped=true"
import script from "./addshopCategory.vue?vue&type=script&lang=js"
export * from "./addshopCategory.vue?vue&type=script&lang=js"
import style0 from "./addshopCategory.vue?vue&type=style&index=0&id=7bc24da9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc24da9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7bc24da9')) {
      api.createRecord('7bc24da9', component.options)
    } else {
      api.reload('7bc24da9', component.options)
    }
    module.hot.accept("./addshopCategory.vue?vue&type=template&id=7bc24da9&scoped=true", function () {
      api.rerender('7bc24da9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/inflowShopManagement/shopList/addshopCategory.vue"
export default component.exports